import Vue from 'vue'
import VueGtm from 'vue-gtm'
import router from '../router'

// adding keys directly to test on staging.

Vue.use(VueGtm, {
  id: process.env.VUE_APP_PORTAL_GTM, // Your GTM single container ID or array of container ids ['GTM-xxxxxxx', 'GTM-yyyyyyy']
  queryParams: {
    // Add url query string when load gtm.js with GTM ID (optional)
    gtm_auth: process.env.VUE_APP_PORTAL_GTM_AUTH,
    gtm_preview: process.env.VUE_APP_PORTAL_GTM_ENV,
    gtm_cookies_win: 'x'
  },
  defer: false, // defaults to false. Script can be set to `defer` to increase page-load-time at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible)
  enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  debug: true, // Whether or not display console logs debugs (optional)
  loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
  vueRouter: router, // Pass the router instance to automatically sync with router (optional)
  ignoredViews: [], // If router, you can exclude some routes name (case insensitive) (optional)
  trackOnNextTick: false // Whether or not call trackView in Vue.nextTick
})
